var map = {
	"./IVECO": 1004,
	"./IVECO.svg": 1004,
	"./IVECO_2": 1005,
	"./IVECO_2.svg": 1005,
	"./RGB_Neom_positivo": 1006,
	"./RGB_Neom_positivo.svg": 1006,
	"./RGB_OPENSALUD_AZUL": 441,
	"./RGB_OPENSALUD_AZUL.png": 441,
	"./RGB_OPENSALUD_AZUL.svg": 539,
	"./_IKEA": 1007,
	"./_IKEA.svg": 1007,
	"./abogalitypro_orange": 1008,
	"./abogalitypro_orange.svg": 1008,
	"./abogalitypro_white": 1009,
	"./abogalitypro_white.svg": 1009,
	"./aon": 1010,
	"./aon.svg": 1010,
	"./barcelo": 1011,
	"./barcelo.svg": 1011,
	"./camaras-fundacion": 1012,
	"./camaras-fundacion.png": 1012,
	"./comunidad-saludable-azul": 1013,
	"./comunidad-saludable-azul.svg": 1013,
	"./fondos-europeos": 1014,
	"./fondos-europeos.png": 1014,
	"./hacienda": 1015,
	"./hacienda-recorte": 1016,
	"./hacienda-recorte.png": 1016,
	"./hacienda.png": 1015,
	"./iberostart": 1017,
	"./iberostart.svg": 1017,
	"./logo-menttum-grande": 1018,
	"./logo-menttum-grande-2": 1019,
	"./logo-menttum-grande-2.png": 1019,
	"./logo-menttum-grande-blanco": 1020,
	"./logo-menttum-grande-blanco.png": 1020,
	"./logo-menttum-grande.png": 1018,
	"./logo-unipromel-azul": 1021,
	"./logo-unipromel-azul.png": 1021,
	"./loreal": 1022,
	"./loreal.svg": 1022,
	"./menttum": 1023,
	"./menttum.svg": 1023,
	"./montero-aramburu": 1024,
	"./montero-aramburu.png": 1024,
	"./mp": 1025,
	"./mp.png": 1025,
	"./msm": 1026,
	"./msm.svg": 1026,
	"./novo-nordisk": 1027,
	"./novo-nordisk.svg": 1027,
	"./openlegal360_orange": 1028,
	"./openlegal360_orange.svg": 1028,
	"./openlegal360_white": 1029,
	"./openlegal360_white.svg": 1029,
	"./openlegal_blue": 1030,
	"./openlegal_blue.svg": 1030,
	"./openlegal_blue_1x1": 1031,
	"./openlegal_blue_1x1.svg": 1031,
	"./openlegal_orange": 442,
	"./openlegal_orange.png": 442,
	"./openlegal_orange.svg": 1633,
	"./openlegal_white": 443,
	"./openlegal_white.png": 443,
	"./openlegal_white.svg": 1634,
	"./openlegalpro_blue": 1032,
	"./openlegalpro_blue.svg": 1032,
	"./openlegalpro_orange": 1033,
	"./openlegalpro_orange.svg": 1033,
	"./openlegalpro_white": 1034,
	"./openlegalpro_white.svg": 1034,
	"./opensalud360-blue": 1035,
	"./opensalud360-blue.svg": 1035,
	"./opensalud360_healthierlives_blue": 1036,
	"./opensalud360_healthierlives_blue.svg": 1036,
	"./opensalud360_healthierlives_color": 1037,
	"./opensalud360_healthierlives_color.svg": 1037,
	"./opensalud360_healthierlives_white": 1038,
	"./opensalud360_healthierlives_white.svg": 1038,
	"./opensalud360_mx_healthierlives_color": 1039,
	"./opensalud360_mx_healthierlives_color.svg": 1039,
	"./opensalud360_mx_healthierlives_white": 1040,
	"./opensalud360_mx_healthierlives_white.svg": 1040,
	"./opensalud360_white": 1041,
	"./opensalud360_white.svg": 1041,
	"./opensalud_blue_mx": 1042,
	"./opensalud_blue_mx.svg": 1042,
	"./opensalud_healthierlives_blue": 1043,
	"./opensalud_healthierlives_blue.svg": 1043,
	"./opensalud_healthierlives_color": 444,
	"./opensalud_healthierlives_color.png": 444,
	"./opensalud_healthierlives_color.svg": 1635,
	"./opensalud_healthierlives_white": 1044,
	"./opensalud_healthierlives_white.svg": 1044,
	"./opensalud_mx_healthierlives_color": 1045,
	"./opensalud_mx_healthierlives_color.png": 1045,
	"./opensalud_mx_healthierlives_white": 1046,
	"./opensalud_mx_healthierlives_white.svg": 1046,
	"./opensalud_newblue_mx": 1047,
	"./opensalud_newblue_mx.svg": 1047,
	"./opensalud_white": 1048,
	"./opensalud_white.svg": 1048,
	"./opensalud_white_mx": 1049,
	"./opensalud_white_mx.svg": 1049,
	"./opensaludmx_healthierlives_color": 445,
	"./opensaludmx_healthierlives_color.png": 445,
	"./opensaludmx_healthierlives_color.svg": 1636,
	"./pacientes-como-tu-azul": 1050,
	"./pacientes-como-tu-azul.svg": 1050,
	"./pepsico": 1051,
	"./pepsico.svg": 1051,
	"./philips_avent": 1052,
	"./philips_avent.svg": 1052,
	"./prime_by_opensalud": 1053,
	"./prime_by_opensalud.svg": 1053,
	"./primebyopensalud-healthierlives-color": 1054,
	"./primebyopensalud-healthierlives-color.svg": 1054,
	"./primebyopensalud-healthierlives-white": 1055,
	"./primebyopensalud-healthierlives-white.svg": 1055,
	"./primesalud_blue": 1056,
	"./primesalud_blue.svg": 1056,
	"./primesalud_blue_02": 1057,
	"./primesalud_blue_02.svg": 1057,
	"./primesalud_blue_powered": 1058,
	"./primesalud_blue_powered.png": 1058,
	"./primesalud_white": 1059,
	"./primesalud_white.svg": 1059,
	"./primesalud_white_02": 1060,
	"./primesalud_white_02.svg": 1060,
	"./programapyme": 1061,
	"./programapyme.png": 1061,
	"./pyme": 1062,
	"./pyme-white": 1063,
	"./pyme-white.png": 1063,
	"./pyme.png": 1062,
	"./santander": 1064,
	"./santander.svg": 1064,
	"./scania": 1065,
	"./scania.png": 1065,
	"./siemens": 1066,
	"./siemens.svg": 1066,
	"./unihealth_blue": 1067,
	"./unihealth_blue.svg": 1067,
	"./unihealth_blue_unipromel": 1068,
	"./unihealth_blue_unipromel.svg": 1068,
	"./unihealth_white": 1069,
	"./unihealth_white.svg": 1069,
	"./union-europea": 1070,
	"./union-europea.png": 1070
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1003;


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos ^\.\/.*$
// module id = 1003
// module chunks = 116